import { useQuery } from '@tanstack/react-query';

interface Image {
  image_id: string;
  filename: string;
  description?: string | null;
  file_url: string;
}

interface Restaurant {
  id?: string;
  name: string;
  OurDescription: string;
  UsersDescription?: string;
  rating?: number;
  rate?: number;
  reviews?: number;
  address?: string;
  opening_hours: string;
  phone?: string;
  website?: string;
  instagram?: string;
  image_names?: string[];
  images?: Image[];
  Menu?: any[];
  food_types?: string[];
  mealTime?: string[];
  Cuisine?: string;
  price_range?: string;
  latitude?: number;
  longitude?: number;
  map_url: string;
  review_summary: string;
  description: string;
  category: string;
  categories: { id: number; name: string }[]; // ✅ اصلاح شد - آرایه از آبجکت
  sub_category: string;
}


const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const fetchPlaceData = async (id: string, signal: AbortSignal): Promise<Restaurant> => {
  const response = await fetch(`${BASE_URL}/api/places/${id}`, {
    headers: { "Content-Type": "application/json" },
    signal,
  });

  if (!response.ok) throw new Error('Failed to fetch restaurant details');

  const body = await response.json();
  return body.data ?? body;
};

export const usePlaceData = (id: string | undefined) => {
  const query = useQuery({
    queryKey: ['place', id],
    queryFn: ({ signal }) => fetchPlaceData(id!, signal),
    enabled: Boolean(id),
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });

  return {
    restaurant: query.data ?? null,
    loading: query.isLoading,
    error: query.error?.message ?? null,
  };
};
